import { of, Subscription } from 'rxjs';
import { DealerClientMappings } from './../../../app.interfaces';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { SocketService } from '../socket/socket.service';
import { DealerClientMappingType } from 'src/app/app.structs';
import { SislWealthClientStatus, SocketConnections, SockRoutes } from 'sharedweb/app.structs';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UccSelectionComponent } from '../../components/ucc-selection/ucc-selection.component';
import { getUccSelectionDialogConfig } from '../../components/ucc-selection/dialog-helper';
import { ConfigurationService } from '../configuration/configuration.service';
import { SislWealthRequest, SislWealthResponse } from 'sharedweb/app.interface';


@Injectable({
  providedIn: 'root'
})
export class ClientListService {
  private _subscriptions: Subscription = new Subscription();
  constructor(
    private _httpClient: HttpClient,
    private _socket: SocketService,
    private _dialog: MatDialog,
    private configService: ConfigurationService
  ) { }

  public result: string[] = [];

  getClientList() {

    this._subscriptions.add(
      this._socket.getFeed(SocketConnections.order, SockRoutes.mapping)
        .subscribe((mapping: DealerClientMappings) => {
          if (mapping && mapping.mapping_type === DealerClientMappingType.mapped) {
            // mapped
            this.result.push(mapping.client);
          } else if (mapping && mapping.mapping_type === DealerClientMappingType.unmapped) {
            // unmapped
            const index = this.result.indexOf(mapping.client);
            if (index > -1) {
              this.result.splice(index, 1);
            }
          }
        }));

    const url = applicationUrls.clientListUrl;
    if (this.result.length) {
      return of(this.result);
    } else {
      return this._httpClient.get<string[]>(url)
        .map(response => {
          this.result = response;
          return this.result;
        });
    }
  }

  /**
   * Gets the SISL Wealth Client URL by making a POST request to the SISL Wealth endpoint
   * 
   * @param request Optional SislWealthRequest object containing selected_id
   * @returns Promise that resolves to:
   * - URL with SSO token if successful authentication
   * - URL with link if status is pending
   * - null if dialog is closed without selection
   * @throws Error if request fails
   */
  async getSISLWealthClientURL(request?: SislWealthRequest) {
    const url = applicationUrls.sislWealthClientUrl;
    try {
      const response = await this._httpClient.post<SislWealthResponse>(url, request).toPromise();

      if (response?.status === SislWealthClientStatus.success) {
        let ssoToken: string;

        if (response.sso_token != null && response.sso_token !== '') {
          ssoToken = response.sso_token;
          if (this.configService.remoteConfigCacheObj.SISL_WEALTH_CLIENT_URL) {
            return `${this.configService.remoteConfigCacheObj.SISL_WEALTH_CLIENT_URL}#/login?SSOToken=${ssoToken}`;
          }
          return `https://shareindia.investwell.app/#/login?SSOToken=${ssoToken}`;
        } else if (response.ucc_list != null && response.ucc_list.length > 0) {
          return new Promise((resolve) => {
            const dialogRef = this._dialog.open(UccSelectionComponent, getUccSelectionDialogConfig({
              ucc_details: response['ucc_list'].map((item: string) => ({
                ucc: item,
                name: item
              })),
              isSislWealth: true
            }));

            dialogRef.afterClosed().subscribe(async (selectedId) => {
              if (selectedId) {
                // Recursively call with selected ID and resolve with the result
                const result = await this.getSISLWealthClientURL({ selected_id: selectedId[0] });
                resolve(result);
              } else {
                resolve(null); // Handle dialog close without selection
              }
            });
          });
        }
      } else if (response?.['status'] === SislWealthClientStatus.pending) {
        if (response['link']) {
          return response['link'];
        }
      }
    } catch (error) {
      console.error('SISL Wealth issue:', error);
      throw error;
    }
  }
}
